import { API } from '@aws-amplify/api'
import { getUsersMinimalData, addUserDropDown } from '../actions'
import { WOMA_API_GATEWAY_NAME } from '../../constants/aws'

export const fetchUserBannerData = () => async (dispatch) => {
  const apiName = 'user-management/users'
  try {
    const options = {
      headers: {},
      response: false,
    }

    const result = await API.get(WOMA_API_GATEWAY_NAME, `/${apiName}`, options)

    if (result?.data) {
      const filteredArray = result.data
        .filter((user) => {
          return user.user_roles?.includes('NL_Pathologist')
        })
        .map((user) => {
          return {
            user_name: user.first_name + ', ' + user.last_name,
            user_id: user.user_id,
          }
        })
      dispatch(getUsersMinimalData({ payload: filteredArray }))
    }
  } catch (err) {
    console.log('Cases Error', err)
  }
}

export const filterUserBannerByIdData =
  ({ payload }) =>
  async (dispatch) => {
    dispatch(addUserDropDown({ payload }))
  }

export const runLoadBalancer =
  ({ payload }) =>
  async () => {
    const apiName = '/case-management/labmanager/invokeLoadBalancer'
    try {
      const options = {
        headers: {},
        response: false,
        body: payload,
      }
      const result = await API.post(WOMA_API_GATEWAY_NAME, `${apiName}`, options)
      console.log('load balancer success', result)
    } catch (err) {
      console.log('load balancer Error', err)
    }
  }
